"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _result = _interopRequireDefault(require("lodash/result"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _moment = _interopRequireDefault(require("moment"));
var _reactCookie = _interopRequireDefault(require("react-cookie"));
var _timeData = require("../data/time-data");
var _timeUtils = require("../data/time-utils");
var _reactIntl = require("react-intl");
var _excluded = ["hasError"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var searchByDateTimeHOC = function searchByDateTimeHOC(Component) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);
    function HOC(props) {
      var _this;
      _classCallCheck(this, HOC);
      _this = _callSuper(this, HOC, [props]);
      _this.state = {
        startTimeIndex: '',
        endTimeIndex: '',
        formError: '',
        selectedDate: null,
        isStartTimeOptional: true,
        isEndTimeOptional: true,
        displayDateTime: ''
      };
      _this.selectStartTime = _this.selectStartTime.bind(_assertThisInitialized(_this));
      _this.selectEndTime = _this.selectEndTime.bind(_assertThisInitialized(_this));
      _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_this));
      _this.clearFilter = _this.clearFilter.bind(_assertThisInitialized(_this));
      _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
      _this.submitFormCb = _this.submitFormCb.bind(_assertThisInitialized(_this));
      _this.onHideFn = _this.onHideFn.bind(_assertThisInitialized(_this));
      _this.inputRefs = {};
      return _this;
    }
    _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var getDateTime = (0, _get.default)(this.props, 'selectedFilters.availability', '');
        if (getDateTime) {
          // Split string to ISO strings for start time and end time ex: [2018-11-15T09:30:00, 2018-11-15T12:00:00]
          // Convert to object ex: { date: 15,  hours: 6, milliseconds: 0, minutes: 0, months: 10, seconds: 0, years: 2018 }
          // Filter in TimeMap for time index that matches the hours and minutes,
          // there will sometimes be two items in the array that gets returned, overnight time and non overnight.
          // ex: { 36: { time_index: 36, time: '12:00 am*', h: 0, m: 0, overnight: true } }
          // For end times, filter for overnight values, by comparing if end date is after start date
          var dateTime = getDateTime.split(',');
          var start = dateTime[2];
          var end = dateTime[3];
          var momentStart = (0, _moment.default)(start);
          var momentEnd = (0, _moment.default)(end);
          var overnight = momentEnd.isAfter(start, 'date');
          var startObject = momentStart.toObject();
          var endObject = momentEnd.toObject();
          var startTimeObj = (0, _filter.default)(_timeData.TimeMap, {
            h: startObject.hours,
            m: startObject.minutes
          })[0] || {};
          var endTimeObj = (0, _filter.default)(_timeData.TimeMap, {
            h: endObject.hours,
            m: endObject.minutes,
            overnight: overnight
          })[0] || {};
          var displayDateTime = this.displayDateTime(momentStart, startTimeObj, endTimeObj);
          var startHash = _timeUtils.TimeUtils.scheduleHash('start', start, startTimeObj.time_index);
          var endHash = _timeUtils.TimeUtils.scheduleHash('end', end, endTimeObj.time_index);
          var hash = (0, _assign.default)({}, startHash, endHash);
          if (startHash) {
            // 24hrs
            var expires = new Date(Date.now() + 1000 * 60 * 60 * 24);
            _reactCookie.default.save('booking_schedule', [hash], {
              path: '/',
              expires: expires
            });
          }
          this.setState({
            startTimeIndex: startTimeObj.time_index,
            endTimeIndex: endTimeObj.time_index,
            selectedDate: momentStart.toDate(),
            displayDateTime: displayDateTime
          });
        }
      }
    }, {
      key: "onDayClick",
      value: function onDayClick(date) {
        this.setState({
          selectedDate: date
        });
      }
    }, {
      key: "onHideFn",
      value: function onHideFn() {
        this.setState({
          formError: ''
        });
      }
    }, {
      key: "formatIsoString",
      value: function formatIsoString(momentDate, startTime, endTime) {
        // convert moment date to object format
        // if there are no start and end times default to start at 6am to 6am next day
        // finally convert start and end date/times to ISO string
        var ISOFormat = 'YYYY-MM-DDTHH:mm:ss';
        var startDateObject = momentDate.toObject();
        var endDateObject = !startTime.h && !endTime.h || endTime.overnight ? momentDate.add(1, 'd').toObject() : momentDate.toObject();
        var startDateTime = (0, _assign.default)({}, startDateObject, {
          hours: (0, _isNumber.default)(startTime.h) ? startTime.h : 6,
          minutes: startTime.m || 0
        });
        var endDateTime = (0, _assign.default)({}, endDateObject, {
          hours: (0, _isNumber.default)(endTime.h) ? endTime.h : 6,
          minutes: endTime.m || 0
        });
        return {
          startDate: (0, _moment.default)(startDateTime).format(ISOFormat),
          endDate: (0, _moment.default)(endDateTime).format(ISOFormat)
        };
      }
    }, {
      key: "displayDateTime",
      value: function displayDateTime(momentDate, startTime, endTime) {
        var intl = this.props.intl;
        var timeString = '';
        if (startTime && startTime.time && endTime && endTime.time) {
          timeString += intl.formatTime((0, _moment.default)(startTime.time, 'LT').format()) + ' - ' + intl.formatTime((0, _moment.default)(endTime.time, 'LT').format());
          ;
        }
        var displayDateTime = "".concat(intl.formatDate(momentDate, {
          month: 'short',
          day: 'numeric'
        }), " ").concat(timeString);
        return displayDateTime;
      }
    }, {
      key: "submitForm",
      value: function submitForm(element, callback, refs, value) {
        return callback(value);
      }
    }, {
      key: "submitFormCb",
      value: function submitFormCb(value) {
        // if there is no date present in the value, then we show an error message
        if (!value.dateInput) return this.setState({
          formError: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "search.search_date_time_hoc.empty_date",
            defaultMessage: "Please select a date."
          })
        });
        // check to see if we have lat and lng defined, otherwise display error
        if (window.map) {
          var lat = (0, _result.default)(window.map || {}, 'center.lat');
          var lng = (0, _result.default)(window.map || {}, 'center.lng');
          if (!lat || !lng) {
            return this.setState({
              formError: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
                id: "search.search_date_time_hoc.filter_error",
                defaultMessage: "We encountered an error with this filter."
              })
            });
          }
        }
        // Find the time map that matches the index of the start time, or default to empty object
        var startTime = _timeData.TimeMap[value.startTimeIndex] || {};
        // Find the time map that matches the index of the end time, or default to empty object
        var endTime = _timeData.TimeMap[value.endTimeIndex] || {};
        var momentDate = (0, _moment.default)(new Date(value.dateInput));
        var IsoDateString = this.formatIsoString(momentDate.clone(), startTime, endTime); // clone to avoid mutation
        var endDate = IsoDateString.endDate,
          startDate = IsoDateString.startDate;
        var startObj = _timeUtils.TimeUtils.scheduleHash('start', startDate, value.startTimeIndex) || {}; // start hash
        var endObj = _timeUtils.TimeUtils.scheduleHash('end', endDate, value.endTimeIndex) || {}; // end hash
        var startEndHash = (0, _assign.default)({}, startObj, endObj);
        // We load the booking_schedule cookie to see if it is the user's first time updating their schedule. For analytics
        var schedule = _reactCookie.default.load('booking_schedule');
        var duration = _moment.default.duration((0, _moment.default)(endDate).diff((0, _moment.default)(startDate))).as('hours');
        // analyticsIntegrations.searchByDate('search page filter', startObj.start, endObj.end, duration, !schedule);

        var displayDateTime = this.displayDateTime(momentDate.clone(), startTime, endTime);
        this.setState({
          displayDateTime: displayDateTime,
          formError: '',
          selectedDateString: "".concat(startDate, ",").concat(endDate)
        });
        if ((0, _isFunction.default)(this.props.filterResults)) {
          this.props.filterResults({
            availability_interval: "".concat(startDate, ",").concat(endDate)
          });
        }
        var expires;
        if (startObj.start) {
          // 24hrs
          expires = new Date(Date.now() + 1000 * 60 * 60 * 24);
        }
        // Save schedule to a cookie so that it populates schedule in listing page
        _reactCookie.default.save('booking_schedule', [startEndHash], {
          path: '/',
          expires: expires
        });
        if ((0, _isFunction.default)(this.props.beforeModalCloseFn)) {
          this.props.beforeModalCloseFn();
        }
        return this.formComponent.close();
      }
    }, {
      key: "selectStartTime",
      value: function selectStartTime(value, closeDropdownCb) {
        this.setState({
          startTimeIndex: value,
          isEndTimeOptional: false
        });
        closeDropdownCb();
      }
    }, {
      key: "selectEndTime",
      value: function selectEndTime(value, closeDropdownCb) {
        this.setState({
          endTimeIndex: value,
          isStartTimeOptional: false
        });
        closeDropdownCb();
      }
    }, {
      key: "clearFilter",
      value: function clearFilter() {
        this.setState({
          startTimeIndex: '',
          endTimeIndex: '',
          selectedDate: null,
          selectedDateString: '',
          isStartTimeOptional: true,
          isEndTimeOptional: true,
          formError: '',
          displayDateTime: ''
        });
        var schedule = _reactCookie.default.load('booking_schedule');
        // analyticsIntegrations.searchByDate('search page filter', null, null, null, !schedule);
        if ((0, _isFunction.default)(this.props.filterResults)) {
          return this.props.filterResults({
            availability_interval: ''
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          hasError = _this$props.hasError,
          restProps = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/_react.default.createElement(Component, _extends({}, restProps, this.state, {
          ref: function ref(_ref) {
            _this2.formComponent = _ref;
          },
          onHideFn: this.onHideFn,
          submitForm: this.submitForm,
          submitFormCb: this.submitFormCb,
          clearFilter: this.clearFilter,
          selectStartTime: this.selectStartTime,
          selectEndTime: this.selectEndTime,
          onDayClick: this.onDayClick
        }));
      }
    }]);
    return HOC;
  }(_react.default.Component);
  HOC.propTypes = {
    filterResults: _propTypes.default.func,
    beforeModalCloseFn: _propTypes.default.func,
    hasError: _propTypes.default.bool
  };
  return (0, _reactIntl.injectIntl)(HOC);
};
var _default = exports.default = searchByDateTimeHOC;